/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedPriceListItemListResponse } from '../types/PaginatedPriceListItemList';
import type { Type } from '../types/Type';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type PriceListItemsListRequest = {} | null | undefined;
export type PriceListItemsListResponse = PaginatedPriceListItemListResponse;

export type PriceListItemsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: type
   * schema:
   *   type: string
   *   enum:
   *     - DATA_RASTER
   *     - DATA_VECTOR
   *     - PRINT
   *     - SERVICES
   * description: |-
   *   * `DATA_VECTOR` - vektorová data
   *   * `DATA_RASTER` - rastrová data
   *   * `SERVICES` - služby
   *   * `PRINT` - tisk
   * ```
   */
  type?: 'DATA_RASTER' | 'DATA_VECTOR' | 'PRINT' | 'SERVICES';

  /**
   * ```yaml
   * in: query
   * name: type__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - DATA_RASTER
   *       - DATA_VECTOR
   *       - PRINT
   *       - SERVICES
   * description: |-
   *   * `DATA_VECTOR` - vektorová data
   *   * `DATA_RASTER` - rastrová data
   *   * `SERVICES` - služby
   *   * `PRINT` - tisk
   * explode: true
   * style: form
   * ```
   */
  type__in?: Type[];
};

/**
 * GET /dmx-server/price_list_items/
 *
 * ```yaml
 * operationId: price_list_items_list
 * tags:
 *   - price_list_items
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedPriceListItemList'
 *     description: ''
 * ```
 */
export const priceListItemsListOperation = (rest?: PriceListItemsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/price_list_items/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/price_list_items/' };
  };

/**
 * GET /dmx-server/price_list_items/
 *
 * ```yaml
 * operationId: price_list_items_list
 * tags:
 *   - price_list_items
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedPriceListItemList'
 *     description: ''
 * ```
 */
export const priceListItemsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: PriceListItemsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedPriceListItemListResponse>> => {
  const operation = priceListItemsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/price_list_items/
 */
export const usePriceListItemsListResource = (
  query: PriceListItemsListQuery | null,
  useCached?: boolean,
): UseResource<PriceListItemsListResponse> => {
  return useResource<PriceListItemsListResponse>({
    path: query === null ? null : priceListItemsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
